import { ApiResourceBaseClass as n } from "./baseApiCalls.js";
const s = "lead_forms", e = "leads";
class c extends n {
  /**
   * Retrieves the fields for a given lead form.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/lead_forms/{lead_form_id}/fields`
   *
   * @param {number} [lead_form_id] - Optional ID of the lead form.
   * @returns {Promise<LeadFormFields>} A promise that resolves to the lead form fields.
   */
  getLeadFormFields = async (t) => {
    const { data: a } = await this.get(`${s}/${t}/fields`);
    return a;
  };
  /**
   * Updates the fields for a given lead form.
   *
   * HTTP Verb: `PATCH`
   * Endpoint URL: `/lead_forms/{lead_form_id}/fields`
   *
   * @param {number} lead_form_id - The ID of the lead form to update.
   * @param {any} payload - The payload containing updated field data.
   * @returns {Promise<LeadFormFields>} A promise that resolves to the updated lead form fields.
   */
  updateLeadFormFields = async (t, a) => {
    const { data: d } = await this.patch(
      `${s}/${t}/fields`,
      a
    );
    return d;
  };
  /**
   * Retrieves a single lead.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/leads/{lead_id}`
   *
   * @param {number} [lead_id] - The ID of the lead to retrieve.
   * @returns {Promise<Lead>} A promise that resolves to the lead data.
   */
  getLead = async (t) => {
    const { data: a } = await this.get(`${e}/${t}`);
    return a;
  };
  /**
   * Retrieves a list of leads filtered by the lead form ID.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/leads`
   *
   * @param {number} lead_form_id - The lead form ID used for filtering leads.
   * @returns {Promise<LeadsData>} A promise that resolves to the list of leads.
   */
  getLeads = async (t) => {
    const { data: a } = await this.get(e, { lead_form_id: t });
    return a;
  };
}
export {
  c as Leads
};
